module.exports = __webpack_public_path__ + "static/media/eye.95210f59.svg";